import React, { useEffect } from 'react';
import { AppBar, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Toolbar } from '@mui/material';
import { useAtom } from 'jotai';
import { modalAtom } from '@/atom/modalAtom';
import styled from 'styled-components';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import { useLocation } from 'react-router-dom';

const Modal = () => {
  const location = useLocation();
  const [modal, setModal] = useAtom(modalAtom);

  const handleCloseModal = () => {
    setModal({ ...modal, isOpen: false });
  };

  useEffect(() => {
    setModal({
      ...modal,
      isOpen: false,
    });
  }, [location.pathname]);

  return (
    <Dialog
      open={modal.isOpen}
      onClose={handleCloseModal}
      fullScreen={modal.fullScreen}
      maxWidth='lg'
    >
      {modal.fullScreen ? (
        <>
          <AppBar sx={{ position: 'relative' }}>
            <Toolbar>
              <IconButton edge='start' color='inherit' onClick={handleCloseModal} aria-label='close'>
                <CloseIcon />
              </IconButton>
              <Typography sx={{ ml: 2, flex: 1 }} variant='h6' component='div'>
                {modal.title}
              </Typography>
            </Toolbar>
          </AppBar>
          <DialogContent>{modal.content}</DialogContent>
          {modal.action && <DialogActions>{modal.action}</DialogActions>}
        </>
      ) : (
        <>
          <DialogTitle>{modal.title}</DialogTitle>
          <DialogContent>{modal.content}</DialogContent>
          {modal.action && <DialogActions>{modal.action}</DialogActions>}
        </>
      )}
    </Dialog>
  );
};

export default Modal;
